export const ADD_TEAM = "ADD_TEAM"
export  const ENABLE_DISABLE_TEAM = "ENABLE_DISABLE_TEAM"
export const SEARCH_TEAM = "SEARCH_TEAM"
export const ON_EDIT_TEAM = "ON_EDIT_TEAM"
export const ON_SAVE_TEAM = "ON_SAVE_TEAM"
export const HANDLE_EDIT_INPUT = "HANDLE_EDIT_INPUT"
export const FETCHING = "TEAM/FETCHING"
export const SUCCESS = "TEAM/SUCESS"
export const ERROR = "TEAM/ERROR"